export default {
  mapContainer : {
    position: 'relative',
    maxWidth: '960px',
    margin: 'auto'
  },
  mapContainerDiv : {
    position: 'absolute'
  }
}